// Copyright (c) 2022 WiseTime. All rights reserved.

import { concat, Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import { grpc } from "../../../app/rpc/executor"
import { postExpectationsClient } from "../../../app/rpc/client"
import * as Slice from "../slices/stats"
import {
  CreateLeaveRequest,
  Leave,
  ListMemberExpectationsRequest,
} from "../../../generated/legebill/site/postexpectation/v4/post_expectation_pb"
import { showSnackBar } from "../../snackbar/actions"

type CreateLeaveRpc = (request: CreateLeaveRequest) => Observable<Leave>

export const createLeave = (createLeaveRpc: CreateLeaveRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.createLeave.match),
      mergeMap(action => of(action.payload)
        .pipe(
          mergeMap(createLeaveRpc),
          mergeMap(response => {
            const request = new ListMemberExpectationsRequest()
              .setSiteId(action.payload.getSiteId())
              .setMembershipId(action.payload.getMembershipId())
              .setStartDate(action.payload.getDate())
              .setEndDate(action.payload.getDate())
            return concat(
              of(Slice.addLeave(response.toObject())),
              of(Actions.refreshMemberExpectations(request)),
            )
          }),
          catchError(() => of(showSnackBar({
            message: t({ id: "msg_create_leave_failed", message: "Failed to add leave. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const createLeaveRpc = (request: CreateLeaveRequest): Observable<Leave> =>
  grpc(() => postExpectationsClient.createLeave(request, null))

export default createLeave(createLeaveRpc)
